import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { projectFirestore } from "../../../firebase/config";
import {
  Table,
  Form,
  Pagination,
  Button,
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
} from "react-bootstrap";
import { faCalendarCheck, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";
import {
  onSnapshot,
  collection,
  query,
  where,
  Timestamp,
  setDoc,
  doc,
} from "firebase/firestore";
import moment from "moment";

// style
import "./Checador.css";

export default function Checador() {
  const { register } = useAuthContext();
  const [dateRange] = useState(null);
  const [data, setData] = useState([]);
  const [modQr, setModQr] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [horasalida, setHorasalida] = useState("");
  const [selecteditem, setSelectedItem] = useState(null);

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  const [dataChec, setDataChec] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const elementsPerPage = 7;

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return dataChec.slice(startIndex, endIndex);
  };

  const guardarRegistro = () => {
    let hour = parseInt(horasalida.substring(0, 2));
    let minutes = parseInt(horasalida.substring(3, 5));
    let registro = DateTime.now().set({ hour: hour, minute: minutes });
    selecteditem.end_date = Timestamp.fromDate(registro.toJSDate());
    setDoc(doc(projectFirestore, "checador", selecteditem.id), selecteditem);
    alert("Se genero el registro de salida");
    setModQr(false);
  };

  useEffect(() => {
    const Listener = () => {
      const localTimeZone = "America/Hermosillo";
      const currentDate = DateTime.now().setZone(localTimeZone);
      const startOfDay = currentDate.startOf("day");
      const endOfDay = currentDate.endOf("day");
      const filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        { campo: "start_date", operador: ">=", valor: startOfDay.toJSDate() },
        { campo: "start_date", operador: "<=", valor: endOfDay.toJSDate() },
      ];
      let q = query(collection(projectFirestore, "checador"));
      filtros.forEach((filtro) => {
        const { campo, operador, valor } = filtro;
        q = query(q, where(campo, operador, valor));
      });
      onSnapshot(q, (docs) => {
        const documentosColeccion = [];
        docs.docs.forEach((doc) => {
          //console.log(doc.id, '=>', doc.data());
          const data = doc.data();
          data.id = doc.id;
          documentosColeccion.push(data);
        });

        setDataChec(documentosColeccion);
      });
    };
    console.log(register);
    var qrText = "https://quickchart.io/qr?text=C-" + register.id;
    var info = {
      id: 1,
      nombre: "QR CHECADOR",
      qr: qrText,
    };
    setData([info]);
    Listener();
  }, [dateRange, register]);

  return (
    <div className="container">
      <br />
      <h4 className="">CHECADOR</h4>
      <div className="row">
        <div className="col-sm-3 "></div>

        <div className="col-sm-9">
          <h4 className="page-title center">
            Registros del dia {DateTime.now().toISODate()}
          </h4>
          <br />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-3">
          <div id="project-qr" className="row">
            {data.map((n, key) => (
              <div key={key} className="center">
                <>
                  <img alt="" className="qr-code" src={n.qr}></img>
                  <div className="center">{n.nombre}</div>
                </>
              </div>
            ))}
          </div>
        </div>

        <div className="col-sm-9">
          <div className="col-sm-6">
            <div className="input-group">
              <Form.Control
                className="form-control border-end-0 border rounded-pill"
                type="text"
                aria-describedby="search-icon"
                placeholder="Busqueda general"
                value={filterText}
                onChange={handleFilterTextChange}
              />
              <span className="input-group-append">
                <button
                  className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                  type="button"
                >
                  <FontAwesomeIcon icon={faSearch} />
                </button>
              </span>
            </div>
          </div>
          <div className="col-sm-4"></div>
          <br />
          <Table striped bordered hover border="2" id="ex-tblChecador">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Entrada</th>
                <th>Salida</th>
              </tr>
            </thead>
            <tbody>
              {getElementsForPage(currentPage)
                .sort()
                .map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{val.user_name}</td>
                      <td>
                        {moment(val.start_date.toDate()).format("hh:mm a zzz")}
                      </td>
                      <td>
                        {val.end_date != null ? (
                          moment(val.end_date.toDate()).format("hh:mm a zzz")
                        ) : (
                          <button
                            onClick={() => {
                              setModQr(true);
                              setSelectedItem(val);
                            }}
                            className="btn btn-primary"
                            id="BtnOption"
                          >
                            <FontAwesomeIcon icon={faCalendarCheck} />
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
          <Pagination>
            {Array.from({
              length: Math.ceil(dataChec.length / elementsPerPage),
            }).map((page, index) => (
              <Pagination.Item
                key={index}
                active={index + 1 === currentPage}
                className={index + 1 === currentPage ? "btn-paginado" : ""}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      </div>
      {/* onExit={{}} onShow={{}} */}
      <Modal show={modQr}>
        <ModalHeader>Registro de salida</ModalHeader>
        <ModalBody>
          Seleccione la hora de salida del empleado.
          <div id="project-qr" className="row">
            <div className="col-sm-12">
              <Form.Group controlId="formName">
                <Form.Label></Form.Label>
                <Form.Control
                  type="time"
                  pattern="[0-9]{0,13}"
                  min={0}
                  onChange={(e) => {
                    setHorasalida(e.target.value);
                  }}
                />
              </Form.Group>
              <br />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="secondary"
            onClick={() => {
              setModQr(false);
            }}
          >
            Cerrar
          </Button>
          <Button variant="primary" onClick={guardarRegistro}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
